import { createFileRoute } from '@tanstack/react-router'
import { QuestionTrash } from '@components'

export const Route = createFileRoute('/questions_/trash/')({
  component: () => <QuestionTrash />,
})
